import { SvgIcon, useTheme } from '@mui/material'

import { Alerts } from 'features/alerts/components/Alerts'
import { AlertData } from 'features/alerts/components/Alerts/types'
import { Alert } from 'features/alerts/types/alert'
import { AdUnitAmazon } from 'features/globalSetup/features/amazon/types/adUnitAmazon'
import { AdUnitAmazonAlert } from 'features/globalSetup/features/amazon/types/adUnitAmazonAlert'
import UnpluggedIcon from 'images/icons/unplugged.svg?react'

type Props = {
  alerts: AdUnitAmazon['alerts']
}

export const AdUnitAmazonAlerts = ({ alerts }: Props): JSX.Element => {
  const theme = useTheme()

  const switcher = (alert: Alert<AdUnitAmazonAlert>): AlertData | undefined => {
    switch (alert.name) {
      case 'enabled':
        return {
          color: theme.palette.warning.main,
          Icon: (
            <SvgIcon
              component={UnpluggedIcon}
              inheritViewBox
            />
          ),
          tooltip: { text: alert.description },
        }

      default:
        throw Error('Missing alert config')
    }
  }

  return <Alerts<AdUnitAmazonAlert> {...{ alerts, switcher }} />
}
